import { useMemo } from "react";

import { Offset, Scale, Size } from "./types";

type SizeCalculations = [Size, Offset, Scale];

const INVALID_DIMENSIONS: SizeCalculations = [
  {
    height: NaN,
    width: NaN,
  },
  {
    x: NaN,
    y: NaN,
  },
  {
    x: NaN,
    y: NaN,
  },
];

export const usePageDimensions = (containerSize: Size, imageSize: Size): SizeCalculations =>
  useMemo((): SizeCalculations => {
    const { height, width } = containerSize;
    // check for any invalid conditions
    if (height < 1 || width < 1 || imageSize.height < 1 || imageSize.width < 1) {
      return INVALID_DIMENSIONS;
    }
    const containerRatio = width / height;
    const imageRatio = imageSize.width / imageSize.height;
    let imgHeight = height;
    let imgWidth = imgHeight * imageRatio;
    if (imageRatio > containerRatio) {
      imgWidth = width;
      imgHeight = imgWidth / imageRatio;
    }
    return [
      { height: imgHeight, width: imgWidth },
      { x: (width - imgWidth) / 2, y: (height - imgHeight) / 2 },
      { x: imgWidth / imageSize.width, y: imgHeight / imageSize.height },
    ];
  }, [imageSize, containerSize]);
